namespace GeniuzPOS.Common {

    @Serenity.Decorators.registerEditor()
    export class PromoDayEditor extends Serenity.Select2Editor<any, any> {

        constructor(container: JQuery) {
            super(container, null);

            
        }

        public getSelect2Options() {
            alert(9);
            debugger
            var selec2Options = super.getSelect2Options();
            selec2Options.multiple = true;
            return selec2Options;
        }

        public get_delimited() {
            return true;
        }

    }
}

